import WrapCards from "@/components/cardsWrap";
import { PrivateCloud_CONSTANTS } from "./constants";

const PrivateCloudCards = () => {
  const { title, desc, list } = PrivateCloud_CONSTANTS;
  return (
    <WrapCards
      title={title}
      desc={desc}
      list={list}
      Width={{
        base: "100%",
        sm: "40vw",
        md: "26vw",
        lg: "20vw",
        "2xl": "19vw",
      }}
      maxWidth={"360px"}
      spacing={{ base: 8, sm: "4vw", md: "3vw", lg: "2vw" }}
      hoverEffect={true}
    />
  );
};

export default PrivateCloudCards;
